<template>
  <b-container class="h-100">
    <div ref="scroll" v-bar>
      <div>
        <div class="d-flex flex-column h-100">
          <div class="text-center my-4">
            <h2 class="h1">Prevádzka</h2>
            <h4 class="text-muted font-weight-normal">
              Jednoducho a rýchlo spracujte, porovnajte a vyhodnoťte spotreby
              energií z podružných meradiel pre efektívne hospodárenie s
              energiami.
            </h4>
          </div>
          <b-row align-h="center" class="flex-grow-1 mb-4">
            <b-col md="5" sm="6">
              <select-picker
                ref="picker"
                v-model="energetics_id"
                :label="['powerNumber', 'gasNumber']"
                btn-variant="primary"
                class="h-100"
                fetch-url="energetics/list"
                picker-class="fh"
                placeholder="Vyberte odberné miesto"
                size="lg"
                visible
                @input="goTo"
              >
                <template #option="props">
                  <div
                    :class="`text-${props.option._type.const.toLowerCase()}`"
                    class="font-weight-bold"
                  >
                    <icon
                      :name="
                        $store.getters['energetic/getTypeByID'](
                          props.option.typeID,
                        ).icon
                      "
                      class="icon-fw"
                      scale="0.75"
                    />
                    {{ props.option.powerNumber || props.option.gasNumber }}
                  </div>
                  <div
                    v-if="props.option.localityName"
                    class="text-muted fs-sm"
                  >
                    {{ props.option.localityName }}
                  </div>
                </template>
              </select-picker>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import SelectPicker from '@/components/inputs/SelectPicker'

export default {
  components: {
    SelectPicker,
  },
  data() {
    return {
      energetics_id: null,
    }
  },
  methods: {
    goTo() {
      this.$store.dispatch(
        'operation/setCurrent',
        this.$refs.picker.selectedItem?.operation_data,
      )
      this.$router.push({
        name: 'operationView',
        params: {
          energetics_id: this.energetics_id,
        },
        //query: {year: this.$moment().year(), month: this.$moment().month() + 1}
      })
    },
  },
}
</script>
